// Feature flags for V1 beta. Flip to true to re-enable for V2.
export const MARKETPLACE_ENABLED = false;

// Stripe is parked until the business bank account arrives (~4 weeks from
// 2026-04-27). While disabled: the Accept button on a customer quote lands
// directly on the success state instead of redirecting to a checkout that
// would fail with empty stripePriceIds. Deposit / pay-now CTAs are also
// hidden everywhere this flag is consulted.
export const STRIPE_ENABLED = false;

// Mini-CRM / kanban job board.
// Live for normal tradie users. God Mode is admin-only and no longer gates it.
export const MINI_CRM_ENABLED = true;

/**
 * Returns true if the mini-CRM should be shown.
 */
export function shouldShowMiniCRM() {
  return MINI_CRM_ENABLED;
}
